// extracted by mini-css-extract-plugin
export default {"iconContainer":"Attachments__iconContainer___h3C3P","skeleton-loading":"Attachments__skeleton-loading___XiS2r"};